import { render, staticRenderFns } from "./CommissionAgreementChangesReturn.vue?vue&type=template&id=246c3928&"
import script from "./CommissionAgreementChangesReturn.vue?vue&type=script&lang=js&"
export * from "./CommissionAgreementChangesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports